"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _constant = require("./constant");
var _AmenitiesCard = require("./AmenitiesCard.proptypes");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Container = _styledComponents.default.div.withConfig({
  displayName: "AmenitiesCard__Container",
  componentId: "sc-3wd8zy-0"
})(function (_ref) {
  var oneColumn = _ref.oneColumn,
    twoColumns = _ref.twoColumns,
    theme = _ref.theme;
  return "\n    display: grid;\n    grid-template-columns: auto auto auto auto;\n    grid-row-gap: ".concat(theme.space.small, ";\n    ").concat(oneColumn ? "grid-template-columns: auto" : '', ";\n    ").concat(twoColumns ? "grid-template-columns: auto auto" : '', ";\n  ");
});
Container.displayName = 'AmenityCardContainer';
var AmenityContainer = _styledComponents.default.div.withConfig({
  displayName: "AmenitiesCard__AmenityContainer",
  componentId: "sc-3wd8zy-1"
})(["display:flex;flex:1;align-items:center;"]);
AmenityContainer.displayName = 'AmenityContainer';
var Title = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "AmenitiesCard__Title",
  componentId: "sc-3wd8zy-2"
})(["font-size:", ";font-weight:", ";line-height:", ";margin-bottom:", ";color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.lineHeight.XLarge;
}, function (_ref5) {
  var theme = _ref5.theme,
    hasSubTitle = _ref5.hasSubTitle;
  return hasSubTitle ? theme.space.mini : theme.space.normal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.neutral;
});
Title.displayName = 'AmenityCardTitle';
var SubTitle = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "AmenitiesCard__SubTitle",
  componentId: "sc-3wd8zy-3"
})(["font-size:", ";font-weight:", ";line-height:", ";margin-bottom:", ";color:", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.normal;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.small;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.XSmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.greyDarker;
});
SubTitle.displayName = 'AmenityCardSubTitle';
var AmenityText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "AmenitiesCard__AmenityText",
  componentId: "sc-3wd8zy-4"
})(["font-size:", ";line-height:", ";color:", ";padding-left:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSize.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.lineHeight.small;
}, function (_ref14) {
  var theme = _ref14.theme,
    textColor = _ref14.textColor;
  return textColor ? theme.colors[textColor] : '#72777e';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.XXXSmall;
});
AmenityText.displayName = 'AmenityText';
var Amenity = function Amenity(_ref16) {
  var amenity = _ref16.amenity,
    accessible = _ref16.accessible,
    iconColor = _ref16.iconColor,
    textColor = _ref16.textColor,
    iconConstent = _ref16.iconConstent;
  var iconMapper = iconConstent || _constant.ICON_MAPPER;
  return /*#__PURE__*/_react.default.createElement(AmenityContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: iconMapper[amenity.id],
    color: iconColor,
    fontsize: "medium"
  }), /*#__PURE__*/_react.default.createElement(AmenityText, {
    accessible: accessible,
    textColor: textColor
  }, amenity.name));
};
Amenity.propTypes = _AmenitiesCard.AmenityPropTypes.PropTypes;
Amenity.defaultProps = _AmenitiesCard.AmenityPropTypes.DefaultProps;
var AmenitiesCard = function AmenitiesCard(props) {
  var title = props.title,
    _props$amenities = props.amenities,
    amenities = _props$amenities === void 0 ? [] : _props$amenities,
    iconColor = props.iconColor,
    accessible = props.accessible,
    theme = props.theme,
    customProperties = props.customProperties,
    subTitle = props.subTitle,
    textColor = props.textColor,
    oneColumn = props.oneColumn,
    twoColumns = props.twoColumns,
    iconConstent = props.iconConstent;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(Title, {
      hasSubTitle: !!subTitle
    }, title), subTitle && /*#__PURE__*/_react.default.createElement(SubTitle, null, subTitle), /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
      tabIndex: tabIndex,
      oneColumn: oneColumn,
      twoColumns: twoColumns
    }, customProperties), amenities.map(function (amenity) {
      return /*#__PURE__*/_react.default.createElement(Amenity, {
        key: "Amenity-".concat(amenity === null || amenity === void 0 ? void 0 : amenity.id),
        amenity: amenity,
        accessible: accessible,
        iconColor: iconColor,
        textColor: textColor,
        iconConstent: iconConstent
      });
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
AmenitiesCard.propTypes = _AmenitiesCard.AmenitiesCardPropTypes.PropTypes;
AmenitiesCard.defaultProps = _AmenitiesCard.AmenitiesCardPropTypes.DefaultProps;
var _default = AmenitiesCard;
exports.default = _default;